import $api from "@/frontend/shared/api/axios";

export enum EErrorType {
  TECHNICAL = "Technical",
  CONTENT_RELATED = "ContentRelated",
  OTHER = "Other"
}

export async function postFounderReportError({ description, type }: { description: string; type: EErrorType }) {
  await $api.post("/founder-revisions/report-error", { description, errorType: type });
}
